/**
 * Shared 16x24 humanoid skeleton. Every part file draws against these
 * numbers so layers stay pixel-aligned across poses.
 *
 * Anchors (down-facing stand): head x=4..11 y=2..8, torso x=5..10 y=10..15,
 * arms x=3..4 / 11..12 y=10..14, legs x=5..10 y=16..20, shoes y=20..22.
 * The composed contour ring adds 1px outside, so art stays in x=2..13, y<=22.
 */
import { bobFor, swingFor } from '../../pixel-kit.js';

export const FOOT_Y = 22; // bottom art row (shoe soles)
export const SHOE_TOP = 20;

export const FRONT = {
  headX0: 4, headX1: 11, headTop: 2, headBot: 8,
  torsoX0: 5, torsoX1: 10, torsoTop: 10, torsoBot: 15,
  armL: 3, armR: 11, // 2px columns
  legTop: 16,
  legLX: 5, legRX: 9, // 2px leg columns, separator between
  shoeLX: 4, shoeRX: 9, // 3px shoes
};

export const SIDE = {
  headX0: 4, headX1: 11, headTop: 2, headBot: 8,
  torsoX0: 6, torsoX1: 10, torsoTop: 10, torsoBot: 15,
  armX: 7, // 2px near-arm column
  legTop: 16,
  hipX: 7, // 2px leg columns swing around this
};

/** Per-frame pose numbers shared by all parts. */
export function poseFor(direction, frame) {
  const swing = swingFor(frame);
  const bob = bobFor(frame);
  if (direction === 'left' || direction === 'right') {
    return {
      bob,
      swing,
      stride: swing * 2, // near-foot x offset; far foot is -stride
      armReach: swing * 2, // near-hand x offset
    };
  }
  return {
    bob,
    swing,
    liftL: frame === 1 ? 1 : 0, // left foot raised on contact A
    liftR: frame === 3 ? 1 : 0, // right foot raised on contact B
    armYL: swing, // left arm drops as left foot lifts
    armYR: -swing,
  };
}
